gsap.registerPlugin(ScrollTrigger);
// –– 1
gsap.set('.co-home-s1 .z-img-desktop', { scale: 1.1, opacity: 0 });
gsap.set('.co-home-s1 .co-anim-element', { y: 40, opacity: 0 });
gsap.set('.utility-bar', { y: -90, opacity: 0 });
gsap.set('.header-wrapper', { y: -90, opacity: 0 });
let cHS1Tl = gsap.timeline({ paused: true });
cHS1Tl.to('.co-home-s1 .z-img-desktop', {
  scale: 1,
  opacity: 1,
  duration: 1,
  ease: "power1.inOut"
});
cHS1Tl.to('.utility-bar', {
  y: 0,
  opacity: 1,
  duration: 1,
  ease: "power1.inOut"
}, "-=0.5");
cHS1Tl.to('.header-wrapper', {
  y: 0,
  opacity: 1,
  duration: 1,
  ease: "power1.inOut"
}, "-=1");
cHS1Tl.to('.co-home-s1 .co-anim-element', {
  y: 0,
  opacity: 1,
  duration: 1,
  stagger: 0.2,
  ease: "power2.inOut"
}, "-=0.5");
cHS1Tl.play();
gsap.set('.co-home-s1_imagebg', { top: "-5%", height: "105%" });
gsap.to('.co-home-s1_imagebg', { 
  scrollTrigger: {
    trigger: '.co-home-s1',
    start: "top top",
    end: "bottom top",
    scrub: true,
  },
  top: "0%"
});
// –– 2
gsap.set('.co-home-s2-content', { opacity: 0 });
gsap.to('.co-home-s2-content', { 
  scrollTrigger: {
    trigger: '.co-home-s2',
    start: "40% bottom",
    end: "bottom top",
  },
  opacity: 1,
  duration: 1,
  ease: "power1.inOut"
});
// –– 3
gsap.set('.co-home-s3-media', { opacity: 0 });
gsap.set('.co-home-s3-content .z-ani-o', { opacity: 0, y: 40 });
let cHS3Tl = gsap.timeline({ paused: true });
cHS3Tl.to('.co-home-s3-media', {
  opacity: 1,
  duration: 1,
  ease: "power1.inOut"
});
cHS3Tl.to('.co-home-s3-content .z-ani-o', {
  y: 0,
  opacity: 1,
  duration: 1,
  stagger: 0.2,
  ease: "power2.inOut"
}, "-=0.9");
ScrollTrigger.create({
  trigger: '.co-home-s3',
  start: "40% bottom",
  end: "bottom top",
  animation: cHS3Tl
});
gsap.set('.co-home-s3-media *', { scale: 1.3 });
gsap.to('.co-home-s3-media *', { 
  scrollTrigger: {
    trigger: '.co-home-s3',
    start: "top bottom",
    end: "bottom top",
    scrub: true,
  },
  scale: 1
});
// –– 4
gsap.set('.co-home-s4 h2', { opacity: 0 });
gsap.set('.co-home-s4-frame', { opacity: 0 });
let cHS4Tl = gsap.timeline({ paused: true });
cHS4Tl.to('.co-home-s4 h2', {
  opacity: 1,
  duration: 1,
  ease: "power1.inOut"
});
cHS4Tl.to('.co-home-s4-frame', {
  opacity: 1,
  duration: 1,
  ease: "power1.inOut"
}, "-=0.8");
ScrollTrigger.create({
  trigger: '.co-home-s4',
  start: "40% bottom",
  end: "bottom top",
  animation: cHS4Tl
});
// –– 5
gsap.set('.co-home-s5-frame .z-ani-o', { opacity: 0, y: 40 });
let cHS5Tl1 = gsap.timeline({ paused: true });
cHS5Tl1.to('.co-home-s5-frame .z-ani-o', {
  y: 0,
  scale: 1,
  opacity: 1,
  duration: 1,
  stagger: 0.2,
  ease: "power2.inOut"
});
ScrollTrigger.create({
  trigger: '.co-home-s5-frame',
  start: "40% bottom",
  end: "bottom top",
  animation: cHS5Tl1
});
const cHS5Swiper1 = new Swiper('.co-home-s5-top-swiper', {
  slidesPerView: 'auto',
  spaceBetween: 0,
  speed: 400,
  loop: false,
  centeredSlides: false,
  // autoplay: {
  //   delay: 3000,
  //   disableOnInteraction: true,
  // },
  watchSlidesProgress: true,
  navigation: {
    nextEl: '.co-home-s5 .swiper-button-next',
    prevEl: '.co-home-s5 .swiper-button-prev',
  },
});
const cHS5Swiper2 = new Swiper('.co-home-s5-bottom-swiper', {
  slidesPerView: 1,
  speed: 0,
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  loop: true,
  allowTouchMove: false,
  thumbs: {
    swiper: cHS5Swiper1
  },
});
cHS5Swiper1.on('slideChange', () => {
  cHS5Swiper2.slideToLoop(cHS5Swiper1.realIndex);
});
document.querySelectorAll('.co-home-s5-bottom-cell').forEach(container => {
  const tabs = container.querySelectorAll('.co-home-s5-bottom-cell-tab');
  const items = container.querySelectorAll('.co-home-s5-bottom-cell-item');
  let currentIndex = 0;
  const autoplayDelay = 3000; 
  const activateTab = (index) => {
    tabs.forEach((t, i) => {
      t.classList.toggle('active', i === index);
      t.setAttribute('aria-selected', i === index ? 'true' : 'false');
    });
    items.forEach((item, i) => {
      item.classList.toggle('active', i === index);
    });
    currentIndex = index;
  };
  tabs.forEach((tab, index) => {
    tab.setAttribute('role', 'button');
    tab.setAttribute('tabindex', '0');
    tab.setAttribute('aria-selected', 'false');
    tab.addEventListener('click', () => {
      activateTab(index);
      resetAutoplay();
    });
    tab.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        activateTab(index);
        resetAutoplay();
      }
    });
  });
  let autoplayInterval = setInterval(() => {
    const nextIndex = (currentIndex + 1) % tabs.length;
    activateTab(nextIndex);
  }, autoplayDelay);
  const resetAutoplay = () => {
    clearInterval(autoplayInterval);
    autoplayInterval = setInterval(() => {
      const nextIndex = (currentIndex + 1) % tabs.length;
      activateTab(nextIndex);
    }, autoplayDelay);
  };
  activateTab(0);
});
// –– 6
const sec6CustomBullets = document.querySelectorAll('.co-home-s6-titles span');
const sec6CustomBulletsArr = Array.from(sec6CustomBullets);
const sec6BulletsArr = sec6CustomBulletsArr.map((item) => item.textContent.trim());
const sec6Swiper = new Swiper('.co-home-s6-swiper', {
  effect: 'fade',
  loop: true,
  autoplay: {
    delay: 2000, 
    disableOnInteraction: false,
  },
  allowTouchMove: false,
  fadeEffect: {
    crossFade: true,
  },
  speed: 500,
  pagination: {
    el: '.co-home-s6 .swiper-pagination',
    clickable: true,
    renderBullet: function (index, className) {
      return '<span class="' + className + '">' + sec6BulletsArr[index] + '</span>';
    },
  },
  navigation: {
    nextEl: '.co-home-s6 .swiper-button-next',
    prevEl: '.co-home-s6 .swiper-button-prev',
  },
  breakpoints: {
    0: {
      slidesPerView: 1,
    },
  },
});
gsap.set('.co-home-s6 .co-home-s6-swiper.z-ani-o', { opacity: 0, scale: 1.025 });
gsap.set('.co-home-s6-pagination h2', { opacity: 0, y: 40 });
gsap.set('.co-home-s6 .swiper-pagination-bullet', { opacity: 0, y: 40 });
let cHS6Tl = gsap.timeline({ paused: true });
cHS6Tl.to('.co-home-s6 .co-home-s6-swiper.z-ani-o', {
  scale: 1,
  opacity: 1,
  duration: 1,
  ease: "power2.inOut"
});
cHS6Tl.to('.co-home-s6-pagination h2', {
  y: 0,
  opacity: 1,
  duration: 1,
  ease: "power2.inOut"
}, "-=0.8");
cHS6Tl.to('.co-home-s6 .swiper-pagination-bullet', {
  y: 0,
  opacity: 1,
  duration: 0.75,
  stagger: 0.1,
  ease: "power2.inOut"
}, "-=0.8");
ScrollTrigger.create({
  trigger: '.co-home-s6',
  start: "40% bottom",
  end: "bottom top",
  animation: cHS6Tl
});
gsap.set('.co-home-s6-parallax', { top: "-10%", height: "110%" });
gsap.to('.co-home-s6-parallax', { 
  scrollTrigger: {
    trigger: '.co-home-s6',
    start: "top bottom",
    end: "bottom top",
    scrub: true,
  },
  top: "0%"
});
// –– 7
// comparePin();
function comparePin() {
  let coMM = gsap.matchMedia();
  document.documentElement.classList.contains('shopify-design-mode') ||
    coMM.add('(min-width: 750px)', () => {
      ScrollTrigger.create({
        trigger: '.co-home-s7-wrapper',
        endTrigger: '.co-home-s7-item__inspiro .co-home-s7-item--frame',
        pin: '.co-home-s7-item__other .co-home-s7-item--frame',
        start: 'top top',
        end: 'top top',
        markers: false,
      });
  });
}
gsap.set('.co-home-s7-heading .z-ani-o', { opacity: 0, y: 40 });
let cHS7Tl1 = gsap.timeline({ paused: true });
cHS7Tl1.to('.co-home-s7-heading .z-ani-o', {
  y: 0,
  scale: 1,
  opacity: 1,
  duration: 1,
  stagger: 0.2,
  ease: "power2.inOut"
});
ScrollTrigger.create({
  trigger: '.co-home-s7-heading',
  start: "40% bottom",
  end: "bottom top",
  animation: cHS7Tl1
});

gsap.set('.co-home-s7-item__other .z-ani-o', { opacity: 0, y: 40 });
let cHS7oTl1 = gsap.timeline({ paused: true });
cHS7oTl1.to('.co-home-s7-item__other .z-ani-o', {
  y: 0,
  scale: 1,
  opacity: 1,
  duration: 1,
  stagger: 0.2,
  ease: "power2.inOut"
});
ScrollTrigger.create({
  trigger: '.co-home-s7-item__other',
  start: "40% bottom",
  end: "bottom top",
  animation: cHS7oTl1
});

gsap.set('.co-home-s7-item__inspiro .z-ani-o', { opacity: 0, y: 40 });
let cHS7iTl1 = gsap.timeline({ paused: true });
cHS7iTl1.to('.co-home-s7-item__inspiro .z-ani-o', {
  y: 0,
  scale: 1,
  opacity: 1,
  duration: 1,
  stagger: 0.2,
  ease: "power2.inOut"
});
ScrollTrigger.create({
  trigger: '.co-home-s7-item__inspiro',
  start: "40% bottom",
  end: "bottom top",
  animation: cHS7iTl1
});
// –– 8
gsap.set('.co-home-s8-img-1.z-ani-o', { opacity: 0, y: -20, x: -5 });
gsap.set('.co-home-s8-img-2.z-ani-o', { opacity: 0, y: 20, x: 5 });
gsap.set('.co-home-s8-text .z-ani-o', { opacity: 0, y: 40 });
let cHS8Tl1 = gsap.timeline({ paused: true });
cHS8Tl1.to('.co-home-s8-img-1.z-ani-o', {
  y: 0,
  x: 0,
  opacity: 1,
  duration: 1,
  ease: "power2.inOut"
});
cHS8Tl1.to('.co-home-s8-img-2.z-ani-o', {
  y: 0,
  x: 0,
  opacity: 1,
  duration: 1,
  ease: "power2.inOut"
}, "-=0.8");
cHS8Tl1.to('.co-home-s8-text .z-ani-o', {
  y: 0,
  scale: 1,
  opacity: 1,
  duration: 1,
  stagger: 0.2,
  ease: "power2.inOut"
}, "-=0.9");
ScrollTrigger.create({
  trigger: '.co-home-s8-text .z-ani-o',
  start: "40% bottom",
  end: "bottom top",
  animation: cHS8Tl1
});
gsap.set('.co-home-s8-img-1 .co-image-type', { y: 0, x: 0 });
gsap.to('.co-home-s8-img-1 .co-image-type', { 
  scrollTrigger: {
    trigger: '.co-home-s8',
    start: "top bottom",
    end: "bottom top",
    scrub: true,
  },
  y: 60,
  x: -10
});
gsap.set('.co-home-s8-img-1 img', { y: -60, height: "calc(100% + 60px)" });
gsap.to('.co-home-s8-img-1 img', { 
  scrollTrigger: {
    trigger: '.co-home-s8',
    start: "top bottom",
    end: "bottom top",
    scrub: true,
  },
  y: 0,
});
gsap.set('.co-home-s8-img-2 .co-image-type', { y: 0, x: 0 });
gsap.to('.co-home-s8-img-2 .co-image-type', { 
  scrollTrigger: {
    trigger: '.co-home-s8',
    start: "top bottom",
    end: "bottom top",
    scrub: true,
  },
  y: -60,
  x: 10
});
gsap.set('.co-home-s8-img-2 img', { y: -60, height: "calc(100% + 60px)" });
gsap.to('.co-home-s8-img-2 img', { 
  scrollTrigger: {
    trigger: '.co-home-s8',
    start: "top bottom",
    end: "bottom top",
    scrub: true,
  },
  y: 0,
});
// –– 9
gsap.set('.co-home-s9 .z-ani-o', { opacity: 0, y: 40 });
let cHS9Tl1 = gsap.timeline({ paused: true });
cHS9Tl1.to('.co-home-s9 .z-ani-o', {
  y: 0,
  opacity: 1,
  duration: 1,
  stagger: 0.2,
  ease: "power2.inOut"
});
ScrollTrigger.create({
  trigger: '.co-home-s9',
  start: "40% bottom",
  end: "bottom top",
  animation: cHS9Tl1
});
// gsap.set('.co-home-s9 .swiper-slide .co-image-type img', { top: "0%" });
// gsap.to('.co-home-s9 .swiper-slide .co-image-type img', { 
//   scrollTrigger: {
//     trigger: '.co-home-s9',
//     start: "top bottom",
//     end: "bottom top",
//     scrub: true,
//   },
//   top: "-10%"
// });

// - 10
gsap.set('.co-home-s10 .z-ani-o', { opacity: 0, y: 40 });
let cHS10Tl1 = gsap.timeline({ paused: true });
cHS10Tl1.to('.co-home-s10 .z-ani-o', {
  y: 0,
  opacity: 1,
  duration: 1,
  stagger: 0.2,
  ease: "power2.inOut"
});
ScrollTrigger.create({
  trigger: '.co-home-s10',
  start: "40% bottom",
  end: "bottom top",
  animation: cHS10Tl1
});
const sec10Swiper = new Swiper('.co-home-s10-swiper', {
  pagination: false,
  watchOverflow: true,
  slidesPerView: 3,

  navigation: {
    nextEl: '.co-home-s10-swiper .swiper-button-next',
    prevEl: '.co-home-s10-swiper .swiper-button-prev',
  },
  breakpoints: {
    0: {
      slidesPerView: 1,
    },
    749: {
      slidesPerView: 2,
    },
    1100: {
      slidesPerView: 3,
    },
  },
});




























